import routes from '@routes/routes'
import { store } from '@store/index'
import { ApplicationState } from '@store/types'

export function getNextRoute() {
  const storeState = store.getState() as ApplicationState
  const { hasEndereco, hasDadosBancarios } = storeState.refinanciamento.dadosPessoais

  if (!hasEndereco) return routes.ENDERECO
  if (hasEndereco && !hasDadosBancarios) return routes.DADOS_BANCARIOS
  return routes.INFORMACOES_PESSOAIS
}
